(function() {
  // Touch / no-hover device check
  if (window.matchMedia('(hover: none)').matches) return;

  const cards = document.querySelectorAll('[data-tilt]');
  if (!cards.length) return;

  const MAX_TILT = 4;   // ±4deg max angle
  const EASE = 0.12;      // lerp factor (0.1 = slow, 0.2 = quicker)

  cards.forEach(card => {
    let targetX = 0, targetY = 0;
    let currentX = 0, currentY = 0;
    let rafId = null;
    let isHovering = false;

    const animate = () => {
      currentX += (targetX - currentX) * EASE;
      currentY += (targetY - currentY) * EASE;

      card.style.transform =
        `perspective(1200px) rotateX(${currentX.toFixed(3)}deg) rotateY(${currentY.toFixed(3)}deg) scale3d(1.005, 1.005, 1.005)`;

      // Keep animating while hovering OR while still settling
      const stillMoving = Math.abs(targetX - currentX) > 0.01 || Math.abs(targetY - currentY) > 0.01;
      if (isHovering || stillMoving) {
        rafId = requestAnimationFrame(animate);
      } else {
        rafId = null;
      }
    };

    const handleMove = (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const cx = rect.width / 2;
      const cy = rect.height / 2;

      targetY = ((x - cx) / cx) * MAX_TILT;
      targetX = -((y - cy) / cy) * MAX_TILT;

      if (!rafId) {
        rafId = requestAnimationFrame(animate);
      }
    };

    const handleEnter = () => {
      isHovering = true;
      card.style.transition = '';
    };

    const handleLeave = () => {
      isHovering = false;
      targetX = 0;
      targetY = 0;
      // Smooth reset via CSS transition for the final settle
      card.style.transition = 'transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)';
      card.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
      currentX = 0;
      currentY = 0;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      setTimeout(() => { card.style.transition = ''; }, 800);
    };

    card.addEventListener('mouseenter', handleEnter);
    card.addEventListener('mousemove', handleMove);
    card.addEventListener('mouseleave', handleLeave);
  });
})();
